import { CardExpiryElement } from '@stripe/react-stripe-js';
import styled from 'styled-components';

import { stripeInputStyles, TProps } from './stripeInputStyles';

export const StyledExpiredElement = styled(CardExpiryElement)<TProps>`
  ${stripeInputStyles}
`;
